import React, { FC } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../../../models";
import { Shops, ShopDetails } from "../../../../../../models/state";
import ShopPickerContent from "../../../../shop-picker/components/ShopPicker/ShopPickerContent";
import { getShops } from "../../../../shop-picker/state/selectors";
import { getSelectedShopInfo } from "../../../state/selectors/deliveryInfoSelectors";

interface StateProps {
    selectedShop?: ShopDetails;
    shops: Shops;
}

interface ConnectedShopPickerProps extends StateProps {
    onShopSelected: (shop?: ShopDetails) => void;
}

const ConnectedShopPicker: FC<ConnectedShopPickerProps> = ({ shops, selectedShop, onShopSelected }) => (
    <ShopPickerContent shopAvailability={shops} selectedShop={selectedShop} onShopSelected={onShopSelected} />
);
const mapStateToProps = (state: RootState): StateProps => ({
    shops: getShops(state),
    selectedShop: getSelectedShopInfo(state),
});

export default connect(mapStateToProps)(ConnectedShopPicker);
